import clsx from "clsx";
import type { MDXComponents } from "mdx/types";

export function buildJobDescriptionComponents(
  bodyTextClass: string,
): MDXComponents {
  return {
    h2: ({ children }) => (
      <h2 className="mt-10 mb-4 font-monument font-medium text-foreground text-2xl">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="mt-8 mb-4 font-monument font-medium text-foreground text-xl">
        {children}
      </h3>
    ),
    p: ({ children }) => (
      <p className={clsx("my-4 text-lg leading-relaxed", bodyTextClass)}>
        {children}
      </p>
    ),
    ul: ({ children }) => (
      <ul className="space-y-2 my-5 pl-6 marker:text-gail-primary list-disc">
        {children}
      </ul>
    ),
    ol: ({ children }) => (
      <ol className="space-y-2 my-5 pl-6 marker:text-gail-primary list-decimal">
        {children}
      </ol>
    ),
    li: ({ children }) => (
      <li className={clsx("pl-1 text-lg leading-relaxed", bodyTextClass)}>
        {children}
      </li>
    ),
  };
}

export const JOB_DESCRIPTION_COMPONENTS =
  buildJobDescriptionComponents("text-black/60");
